import React from 'react'
import { I18nHtml } from 'shared'
import { PaymentMethodProps } from '../types'

export const DirectDepositInfo = ({ paymentMethod }: PaymentMethodProps) => {
  if (paymentMethod !== 'direct_deposit') return null
  return (
    <div className="-mt-2 mb-3 desktop:-mt-3 bg-yellow-100 p-3">
      <I18nHtml as="p" className="m-0" i18nKey="donate.direct_deposit_info" />
    </div>
  )
}
